<template>
    <div class="wrapper">
        <div class="section section-pricing-4">
            <div id="price"  class="container">
                <div class="md-layout">
                    <div
                            class="md-layout-item md-size-70 md-small-size-100 justify-content-center mx-auto text-center"
                    >
                        <h2 class="title">
                            Наши тарифы
                        </h2>
                        <h5 class="description">
                            Все обновления программного обеспечения и техподдержка предоставляются бесплатно, в неограниченном объеме. При увеличении количества устройств вы автоматически переключаетесь на новый тариф.
                        </h5>
                    </div>
                </div>
                <div class="md-layout justify-content-center ">
                    <div class="md-layout-item md-size-25 md-small-size-100" v-on:click="selectPriceCard(0)">
                        <pricing-card :card-bg="activeCard[0]" >
                            <template slot="cardContent">
                                <h6 class="card-category text-gray">
                                    Базовый
                                </h6>
                                <h1 class="card-title">
                                    <small><i class="fas fa-ruble-sign"></i></small>{{tarif[currentTarif].price}}
                                </h1>
                                <ul>
                                    <li>
                                        за устройство в месяц
                                    </li>
                                    <li>
                                        <a v-on:click="changePricesMinus" v-if="currentTarif>0">
                                            <span class="material-icons">remove_circle_outline</span>
                                        </a>

                                        <b> {{tarif[currentTarif].name}} </b>
                                        <a v-on:click="changePricesPlus"  v-if="currentTarif<3">
                                            <span class="material-icons" style="">add_circle_outline</span>
                                        </a>
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> безлимит на фото товаров
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> безлимит на приложение "Заказ"
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> GPS контроль
                                    </li>
                                </ul>

                                <md-button
                                        href="#connect"
                                        class="md-success md-round"
                                >
                                    Подключить
                                </md-button>
                            </template>
                        </pricing-card>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100" v-on:click="selectPriceCard(1)">
                        <pricing-card :card-bg="activeCard[1]" >
                            <template slot="cardContent">
                                <h6 class="card-category text-gray">
                                    Безлимит до 100
                                </h6>
                                <h1 class="card-title">
                                    <small><i class="fas fa-ruble-sign"></i></small>9000
                                </h1>
                                <ul>
                                    <li>
                                        в месяц
                                    </li>
                                    <li>
                                        <b>  31 - 99 устройств </b>
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> безлимит на фото товаров
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> безлимит на приложение "Заказ"
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> GPS контроль
                                    </li>
                                </ul>

                                <md-button
                                        href="#connect"
                                        class="md-success md-round"
                                >
                                    Подключить
                                </md-button>
                            </template>
                        </pricing-card>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100" v-on:click="selectPriceCard(2)">
                        <pricing-card :card-bg="activeCard[2]">
                            <template slot="cardContent">
                                <h6 class="card-category text-gray">
                                    Корпоративный
                                </h6>
                                <h1 class="card-title">
                                    <small><i class="fas fa-ruble-sign"></i></small>90
                                </h1>
                                <ul>
                                    <li>
                                        за устройство в месяц
                                    </li>
                                    <li>
                                        <b>от 100 устройств</b>
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> безлимит на фото товаров
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> безлимит на приложение "Заказ"
                                    </li>
                                    <li>
                                        <md-icon class="text-success">
                                            check
                                        </md-icon> GPS контроль
                                    </li>
                                </ul>

                                <md-button
                                        href="#connect"
                                        class="md-success md-round"
                                >
                                    Подключить
                                </md-button>
                            </template>
                        </pricing-card>
                    </div>
                </div>
                <div class="md-layout">
                    <div
                            class="md-layout-item md-size-70 md-small-size-100 justify-content-center mx-auto text-left"
                    >
                        <p>
                            Устройством считается экземпляр приложения "Akitorg Мобильная торговля" который в течении расчетного месяца создал хотя бы один документ.
                            И экземпляр приложения "Akitorg Супервайзер" который в течении расчетного месяца запросил хотябы один отчет. Если программа не использовалась в расчетном периоде, то плата не начисляется.

                        </p>
                        <p>
                            Функция непрерывной записи координат GPS-трекинг тарифицируется отдельно - 5 рублей в день за устройство. Подключение и настройка расписания записи  происходит в 1С, самостоятельно.
                        </p>
                    </div>
                </div>
            </div>
            <a name="connect"></a>
        </div>
    </div>
</template>

<script>
  import { Tabs, FullBgCard, PricingCard } from "@/components";

  export default {
    name: "BlockPrice",
    components: {
      PricingCard,
      // FullBgCard,
      // Tabs
    },
    data() {
      return {
        activeCard: ["","success",""],
        currentTarif: 0,
        tarif: [
          {
            price: 450,
            name: "до 10 устройств"
          },
          {
            price: 405,
            name: "11 - 15 устройств"
          },
          {
            price: 360,
            name: "16 - 25 устройств"
          },
          {
            price: 315,
            name:  "26 - 30 устройств"
          }
            ],

      };
    },
    methods: {

      changePricesMinus() {
        if (this.currentTarif > 0){
          this.currentTarif = this.currentTarif - 1;
        }
      },
      changePricesPlus() {
        if (this.currentTarif < 3){
          this.currentTarif = this.currentTarif + 1;
        }

      },
      selectPriceCard (card) {
        if (card == 0 ){
          this.activeCard = ["success","",""];
        }
        if (card == 1 ){
          this.activeCard = ["","success",""];
        }
        if (card == 2 ){
          this.activeCard = ["","","success"];
        }

      }
    }
  };
</script>

<style lang="scss">
</style>